<script>
  export let size;
  export let style = "";
</script>

<svg
  width={size}
  height={size}
  {style}
  class="icon"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 21.53 22.06"
  ><defs
    ><style>
      .policy {
        fill: #db4157;
      }
      .policy-off {
        fill: #010101;
      }
    </style></defs
  ><g id="Layer_2" data-name="Layer 2"
    ><g id="KEY"
      ><ellipse
        class="policy"
        cx="10.77"
        cy="11.03"
        rx="10.77"
        ry="11.03"
      /><rect
        class="policy-off"
        x="5.99"
        y="9.85"
        width="2.15"
        height="3.61"
      /><rect
        class="policy-off"
        x="9.69"
        y="9.85"
        width="2.15"
        height="3.61"
      /><rect
        class="policy-off"
        x="13.39"
        y="9.85"
        width="2.15"
        height="3.61"
      /><rect
        class="policy-off"
        x="9.67"
        y="9.07"
        width="2.2"
        height="12.97"
        transform="translate(26.32 4.79) rotate(90)"
      /><polygon
        class="policy-off"
        points="4.29 8.86 10.77 3.05 17.25 8.86 4.29 8.86"
      /></g
    ></g
  ></svg
>
